import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess, exhDescriptionActionId, stallTypeActionId } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import Pagination from "../../../../../utils/pagination";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { insertUpdateStallPossessionChecklist_action, getStallPossessionChecklistDetails_action } from '../../../../../actions/admin_module_action/master_action/exhibition_master_action/stallPossessionChecklist_action';
import { Category, Checklist } from "@mui/icons-material";

class StallPossessionChecklist extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            ExihibitionID: '',
            StallPossessionChecklistList: [
                {
                    Category: '',
                    Checklist: '',
                    id: 1,
                    SeqNo: 1,
                    parentId: 1,
                    isParent: true,
                    isChild: false,
                    StallPossessionChecklistID: null,
                    ActionID: 1,
                    IsDDshow: false,
                    IsBare: false,
                    IsShell: false,
                }
            ],
            deletedRecordList: [],
            stallTypeList: []
        }
    }

    async componentDidMount() {
        await this.getFillList(stallTypeActionId, "", "", "", "", "");

        this.setState({
            ExihibitionID: this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : null
        })
        setTimeout(() => {

            this.getStallPossessionChecklistDetails()
        }, 200);
    }

    async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
        this.setState({ isLoading: true });

        try {
            const data = await this.props.fill_action(
                actionID,
                exhibitionID,
                moduleID,
                keyValue,
                value
            );

            if (data && data.error !== 1) {
                if (actionID === stallTypeActionId) {
                    this.setState({ stallTypeList: data.data });
                }
                return data.data; // ✅ ALWAYS return here
            }

            return null; // ✅ explicit return when error === 1
        } catch (e) {
            console.log(e);
            return null; // ✅ explicit return on error
        } finally {
            this.setState({ isLoading: false });
        }
    }

    getStallPossessionChecklistDetails() {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getStallPossessionChecklistDetails_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data !== '') {

                        let result = [];
                        let categoryMap = {};
                        let parentSeq = 1;

                        // Sort by original Seqno
                        data.data.sort((a, b) => a.Seqno - b.Seqno);

                        data.data.forEach(item => {

                            // Create parent when encountering new category
                            if (!categoryMap[item.Category]) {

                                let parent = {
                                    Category: item.Category,
                                    Checklist: "",
                                    SeqNo: parentSeq,          // Parent numbering: 1, 2, 3...
                                    id: parentSeq,             // ✔ No P prefix
                                    isChild: false,
                                    isParent: true,
                                    parentId: parentSeq,
                                    ActionID: 2,
                                    StallPossessionChecklistID: item.StallPossessionChecklistID,
                                };

                                result.push(parent);

                                // Store child counter for this category
                                categoryMap[item.Category] = {
                                    parentId: parentSeq,
                                    childCounter: 1
                                };

                                parentSeq++;
                            }

                            // Add child row
                            const group = categoryMap[item.Category];
                            const childSeq = `${group.parentId}.${group.childCounter}`;

                            let child = {
                                Category: item.Category,
                                Checklist: item.Checklist,
                                SeqNo: childSeq,              // ✔ 1.1, 1.2, etc.
                                id: item.Seqno,               // ✔ Real ID, no prefix
                                isChild: true,
                                isParent: false,
                                parentId: group.parentId,
                                ActionID: 2,
                                StallPossessionChecklistID: item.StallPossessionChecklistID,
                                IsDDshow: item.IsDDshow,
                                IsBare: item.IsBare,
                                IsShell: item.IsShell,
                            };

                            result.push(child);
                            group.childCounter++;
                        });

                        this.setState({ StallPossessionChecklistList: result });
                    }

                    this.setState({ isLoading: false });

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    insertUpdateStallPossessionChecklist() {
        const { ExihibitionID, StallPossessionChecklistList, deletedRecordList } = this.state

        const array = []

        StallPossessionChecklistList.map((item) => {
            if (item.isParent != 1) {
                array.push({
                    StallPossessionChecklistID: item.StallPossessionChecklistID,
                    Category: item.Category,
                    Checklist: item.Checklist,
                    ActionID: item.ActionID,
                    Seqno: item.id,
                    IsDDshow: item.IsDDshow,
                    IsBare: item.IsBare,
                    IsShell: item.IsShell,
                })
            }
        })

        const isCheckedFill = array.some(item => !item.Category?.trim() || !item.Checklist?.trim());

        if (isCheckedFill) {
            return toastError("Please enter all descriptions.")
        }

        const parents = StallPossessionChecklistList.filter(item => item.isParent);
        const hasDuplicateCategory = parents
            .map(obj => obj.Category.trim())
            .some((cat, idx, arr) => arr.indexOf(cat) !== idx);

        if (hasDuplicateCategory) {
            return toastError("Cannot insert duplicate category!")
        }

        const allParentsHaveChild = parents.every(parent =>
            StallPossessionChecklistList.some(
                item => item.isChild && item.parentId === parent.id
            )
        );
        if (!allParentsHaveChild) {
            return toastError("Please add at least one checklist against category")
        }

        this.setState({ isLoading: true })
        this.props.insertUpdateStallPossessionChecklist_action(ExihibitionID, [...array, ...deletedRecordList])
            .then((data) => {
                if (data.error != 1) {
                    this.getStallPossessionChecklistDetails()
                    toastSuccess("data updated Successfuly!")
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    getWriteAccess() {
        const { loginAccesslist } = this.state
        if (JSON.parse(sessionStorage.getItem('loginDataSS')).UserID == 233) {
            return false
        } else {
            return true
        }
    }


    addChild(parentId, position = null) {
        const { StallPossessionChecklistList } = this.state;

        // Find the parent index
        const parentIndex = StallPossessionChecklistList.findIndex(item => item.id == parentId);

        if (parentIndex !== -1) {
            // Determine where to insert
            let insertIndex = position !== null ? position : parentIndex + 1;

            // Get base parent id (number, like 1)
            const parentBaseId = Math.floor(parentId);

            // Find existing children of this parent
            const children = StallPossessionChecklistList.filter(
                item => item.parentId == parentBaseId && item.isChild
            );

            // Find next child index properly
            let nextChildNo = children.length > 0
                ? Math.max(...children.map(item => parseInt(item.id.toString().split(".")[1], 10))) + 1
                : 1;

            // New child id in string format ("1.10", "1.11", etc.)
            const newId = `${parentBaseId}.${nextChildNo}`;

            // Get parent's category
            const parentObj = StallPossessionChecklistList.find(
                obj => obj.id == parentBaseId && obj.isParent
            );
            const category = parentObj ? parentObj.Category : "";

            // Create new child item
            const newItem = {
                id: newId,
                SeqNo: StallPossessionChecklistList.length + 1, // temporary, will fix later
                parentId: parentBaseId,
                isParent: false,
                isChild: true,
                Category: category,
                Checklist: '',
                StallPossessionChecklistID: null,
                ActionID: 1
            };

            // Insert new child
            StallPossessionChecklistList.splice(insertIndex, 0, newItem);

            // 🔑 Renumber children IDs (so they are continuous 1.1, 1.2, … 1.10, etc.)
            let childCounter = 1;
            StallPossessionChecklistList.forEach(item => {
                if (item.parentId == parentBaseId && item.isChild) {
                    item.id = `${parentBaseId}.${childCounter}`;
                    item.Category = category;
                    childCounter++;
                }
            });

            // 🔑 Recalculate SeqNo for ALL items (just like your previous code)
            StallPossessionChecklistList.forEach((item, i) => {
                item.SeqNo = i + 1;
            });

            console.log('StallPossessionChecklistList ----->', StallPossessionChecklistList);

            this.setState({ StallPossessionChecklistList });
        } else {
            console.log('Parent ID not found');
        }
    }


    addParent(i) {
        const { StallPossessionChecklistList } = this.state

        const parents = StallPossessionChecklistList.filter(item => item.isParent);

        const allParentsHaveChild = parents.every(parent =>
            StallPossessionChecklistList.some(
                item => item.isChild && item.parentId === parent.id
            )
        );
        if (!allParentsHaveChild) {
            return toastError("Please add at least one checklist")
        }

        const array = []
        StallPossessionChecklistList.map(data => {
            if (data.isParent) {
                array.push(data)
            }
        })
        StallPossessionChecklistList.push(
            {
                id: array.length + 1,
                parentId: array.length + 1,
                SeqNo: StallPossessionChecklistList.length + 1,
                isParent: true,
                isChild: false,
                Category: '',
                Checklist: '',
                StallPossessionChecklistID: null,
                ActionID: 1
            }
        )
        console.log('StallPossessionChecklistList----->', StallPossessionChecklistList);
        this.setState({ StallPossessionChecklistList: StallPossessionChecklistList })
    }

    checkForDuplicates(arr, keys) {
        const seen = new Set();
        for (const obj of arr) {
            const uniqueKey = keys.map(key => obj[key]).join('|');
            if (seen.has(uniqueKey)) {
                return true; // Duplicate found
            }
            seen.add(uniqueKey);
        }
        return false; // No duplicates found
    }


    deleteStallPossessionChecklistListList(id, SeminarID) {
        const { StallPossessionChecklistList, deletedRecordList } = this.state;
        // Identify if the item to be deleted is a parent
        const itemToDelete = StallPossessionChecklistList.find(item => item.id === id);
        const isParent = itemToDelete.isParent;


        let updatedList;
        let deletedList;

        if (isParent) {
            // Delete the parent and all its children
            const parentBaseId = Math.floor(id);
            updatedList = StallPossessionChecklistList.filter(item => Math.floor(item.id) !== parentBaseId);
            deletedList = StallPossessionChecklistList.filter(item => Math.floor(item.id) == parentBaseId);
        } else {
            // Delete only the child
            updatedList = StallPossessionChecklistList.filter(item => item.id !== id);
            deletedList = StallPossessionChecklistList.filter(item => item.id == id);
        }


        deletedList.map(item => {
            deletedRecordList.push({ ...item, ActionID: 3 })
        })

        // Reassign IDs for remaining parents and their children
        let parentCounter = 1;
        updatedList = updatedList.map((item) => {
            if (item.isParent) {
                const newParentId = parentCounter;
                const oldParentId = Math.floor(item.id);

                // Update this parent ID
                item.id = newParentId;
                item.parentId = newParentId;
                // Update parent ID to be sequential

                // Update all its children IDs
                let childCounter = 1;
                updatedList.forEach(childItem => {
                    if (Math.floor(childItem.id) === oldParentId && !childItem.isParent) {
                        childItem.id = parseFloat(`${newParentId}.${childCounter}`);
                        childCounter++;
                        childItem.parentId = newParentId;
                    }
                });

                parentCounter++;
            }
            return item;
        });

        console.log("updatedList-->", updatedList)
        if (updatedList.length > 0) {
            updatedList.map((item, i) => {
                item.SeqNo = i + 1
            })
            this.setState({ StallPossessionChecklistList: updatedList });
        } else {
            this.setState({
                StallPossessionChecklistList: [
                    {
                        id: 1,
                        SeqNo: 1,
                        isParent: true,
                        isChild: false,
                        Category: '',
                        Checklist: '',
                        StallPossessionChecklistID: null,
                        ActionID: 1,
                        parentId: 1,
                    }
                ]
            });
        }
    }

    onInputChange(e, i, param, flag) {
        const { StallPossessionChecklistList } = this.state
        let parentId
        let parentCategory
        StallPossessionChecklistList.map((data, index) => {
            if (i === index) {
                if (param == 'Category') {
                    parentId = data.parentId
                    data.Category = e.target.value
                    parentCategory = e.target.value
                } else if (param == 'Checklist') {
                    data.Checklist = e.target.value
                } else if (param == 'IsDDshow') {
                    data.IsDDshow = e.target.checked
                } else if (param == 'IsBare') {
                    data.IsBare = e.target.checked
                } else if (param == 'IsShell') {
                    data.IsShell = e.target.checked
                }
            }
        })

        StallPossessionChecklistList.map((data, index) => {
            if (data.parentId === parentId) {
                data.Category = parentCategory
            }
        })

        this.setState({ StallPossessionChecklistList: StallPossessionChecklistList })
    }

    // --- Helper to extract a parent block (parent + children) ---
    // --- Helper: get parent block (parent + children) ---
    getParentBlock = (list, parentIndex) => {
        const block = [];
        const parent = list[parentIndex];
        block.push(parent);

        // collect children that immediately follow parent
        for (let i = parentIndex + 1; i < list.length; i++) {
            if (list[i].isParent == 1) break; // stop when next parent found
            block.push(list[i]);
        }

        return block;
    };

    // --- Helper: extract parent block (parent + children) ---
    getParentBlock = (list, parentIndex) => {
        const block = [];
        const parent = list[parentIndex];
        block.push(parent);

        for (let i = parentIndex + 1; i < list.length; i++) {
            if (list[i].isParent == 1) break; // stop at next parent
            block.push(list[i]);              // include children
        }
        return block;
    };

    // --- Helper: reassign IDs and SeqNo hierarchically ---
    // --- Helper: extract parent block (parent + children) ---
    getParentBlock = (list, parentIndex) => {
        const block = [];
        const parent = list[parentIndex];
        block.push(parent);

        for (let i = parentIndex + 1; i < list.length; i++) {
            if (list[i].isParent == 1) break; // stop at next parent
            block.push(list[i]);              // include children
        }
        return block;
    };

    // --- Helper: reassign IDs and SeqNo hierarchically ---
    reassignHierarchy = (list) => {
        let parentCounter = 1;
        const newList = [];

        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (item.isParent == 1) {
                const newParentId = parentCounter;

                // update parent
                item.id = newParentId;
                item.parentId = newParentId;
                newList.push(item);

                // update children immediately following parent
                let childCounter = 1;
                let j = i + 1;
                while (j < list.length && list[j].isParent == 0) {
                    list[j].id = parseFloat(`${newParentId}.${childCounter}`);
                    list[j].parentId = newParentId;
                    newList.push(list[j]);
                    childCounter++;
                    j++;
                }

                parentCounter++;
            }
        }

        // update SeqNo
        newList.forEach((it, i) => {
            it.SeqNo = i + 1;
        });

        return newList;
    };

    // --- Move Up ---
    moveUp = (id) => {
        this.setState(prevState => {
            let list = [...prevState.StallPossessionChecklistList];
            let index = list.findIndex(d => d.id === id);
            if (index <= 0) return { StallPossessionChecklistList: list };

            const item = list[index];

            if (item.isParent == 1) {
                // move whole parent+children block
                const block = this.getParentBlock(list, index);
                list.splice(index, block.length);

                // find previous parent position
                let prevParentIndex = -1;
                for (let i = index - 1; i >= 0; i--) {
                    if (list[i].isParent == 1) {
                        prevParentIndex = i;
                        break;
                    }
                }

                if (prevParentIndex >= 0) {
                    list.splice(prevParentIndex, 0, ...block);
                } else {
                    list.splice(0, 0, ...block);
                }
            } else {
                // child: swap with previous sibling only
                const parentId = item.parentId;
                const siblings = list.filter(d => d.parentId === parentId && d.isParent == 0);
                const siblingIndexes = siblings.map(s => list.findIndex(d => d.id === s.id));
                const indexInSiblings = siblingIndexes.indexOf(index);

                if (indexInSiblings > 0) {
                    const swapIndex = siblingIndexes[indexInSiblings - 1];
                    [list[index], list[swapIndex]] = [list[swapIndex], list[index]];
                }
            }

            list = this.reassignHierarchy(list);
            return { StallPossessionChecklistList: list };
        });
    };

    // --- Move Down ---
    moveDown = (id) => {
        this.setState(prevState => {
            let list = [...prevState.StallPossessionChecklistList];
            let index = list.findIndex(d => d.id === id);
            if (index < 0 || index >= list.length - 1) return { StallPossessionChecklistList: list };

            const item = list[index];

            if (item.isParent == 1) {
                // move whole parent+children block
                const block = this.getParentBlock(list, index);
                list.splice(index, block.length);

                // find next parent position
                let nextParentIndex = -1;
                for (let i = index; i < list.length; i++) {
                    if (list[i].isParent == 1) {
                        nextParentIndex = i;
                        break;
                    }
                }

                if (nextParentIndex >= 0) {
                    // insert after next parent + its children
                    let insertIndex = nextParentIndex + 1;
                    while (insertIndex < list.length && list[insertIndex].isParent == 0) {
                        insertIndex++;
                    }
                    list.splice(insertIndex, 0, ...block);
                } else {
                    list.push(...block);
                }
            } else {
                // child: swap with next sibling only
                const parentId = item.parentId;
                const siblings = list.filter(d => d.parentId === parentId && d.isParent == 0);
                const siblingIndexes = siblings.map(s => list.findIndex(d => d.id === s.id));
                const indexInSiblings = siblingIndexes.indexOf(index);

                if (indexInSiblings < siblingIndexes.length - 1) {
                    const swapIndex = siblingIndexes[indexInSiblings + 1];
                    [list[index], list[swapIndex]] = [list[swapIndex], list[index]];
                }
            }

            list = this.reassignHierarchy(list);
            return { StallPossessionChecklistList: list };
        });
    };


    record(StallPossessionChecklistList) {
        const { stallTypeList } = this.state
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-2">
                <thead>
                    <tr style={{ border: '1px solid #ccc' }}>
                        <th className="text-center">Seq No</th>
                        <th className="text-center">Action</th>
                        <th className="text-left" style={{ width: '50px' }}>Section</th>
                        <th className="text-left">Description</th>
                        <th className="text-center" style={{ width: '10px' }}>DD Show</th>
                        <th className="text-left" style={{ width: '150px' }}>Stall Type</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        StallPossessionChecklistList && StallPossessionChecklistList.length > 0 ? (
                            StallPossessionChecklistList.map((data, i) => {
                                const isParent = data.isParent == 1;

                                // --- find siblings based on parent or child ---
                                let siblings = [];
                                if (isParent) {
                                    siblings = StallPossessionChecklistList.filter(d => d.isParent == 1);
                                } else {
                                    siblings = StallPossessionChecklistList.filter(
                                        d => d.parentId === data.parentId && d.isParent == 0
                                    );
                                }

                                const indexInSiblings = siblings.findIndex(d => d.id === data.id);
                                const isFirst = indexInSiblings === 0;
                                const isLast = indexInSiblings === siblings.length - 1;
                                const hasMultiple = siblings.length > 1;
                                if (data.ActionID == 3) {
                                    return
                                }
                                return (
                                    <tr key={i} className={isParent ? "seminar" : ''}>
                                        <td style={{ width: '10px' }}>{data.id}</td>
                                        <td style={{ width: '10px' }} className="text-left">
                                            {/* Add checklist only for parent */}
                                            {/* {isParent && ( */}
                                            <button
                                                title="Add Checklist"
                                                className="btn btn-sm padding_0"
                                                onClick={() => this.addChild(data.id)}
                                            >
                                                <i className="fa fa-plus action_btn_table"></i>
                                            </button>
                                            {/* )} */}

                                            {/* Delete */}
                                            <button
                                                title="Delete"
                                                className="btn btn-sm padding_0"
                                                onClick={() => this.deleteStallPossessionChecklistListList(data.id)}
                                            >
                                                <i className="fa fa-trash action_btn_table"></i>
                                            </button>

                                            {/* Up Arrow */}
                                            {hasMultiple && !isFirst && (
                                                <button
                                                    title="Move Up"
                                                    className="btn btn-sm padding_0"
                                                    onClick={() => this.moveUp(data.id)}
                                                >
                                                    <i className="fa fa-arrow-up"></i>
                                                </button>
                                            )}

                                            {/* Down Arrow */}
                                            {hasMultiple && !isLast && (
                                                <button
                                                    title="Move Down"
                                                    className="btn btn-sm padding_0"
                                                    onClick={() => this.moveDown(data.id)}
                                                >
                                                    <i className="fa fa-arrow-down"></i>
                                                </button>
                                            )}
                                        </td>
                                        <td>{isParent ? 'Category' : 'Checklist'}</td>

                                        {isParent ?
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    maxLength={990}
                                                    value={data.Category}
                                                    onChange={(e) => this.onInputChange(e, i, 'Category')}
                                                />
                                            </td> :
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    maxLength={1950}
                                                    value={data.Checklist}
                                                    onChange={(e) => this.onInputChange(e, i, 'Checklist')}
                                                />
                                            </td>
                                        }
                                        {!isParent ?
                                            <>
                                                <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={data.IsDDshow}
                                                        onChange={(e) => this.onInputChange(e, i, 'IsDDshow')}
                                                    />
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ justifyContent: 'center' }}>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={data.IsBare}
                                                                onChange={(e) => this.onInputChange(e, i, 'IsBare')}
                                                            />
                                                            &nbsp;Bare
                                                        </label>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={data.IsShell}
                                                                onChange={(e) => this.onInputChange(e, i, 'IsShell')}
                                                            />
                                                            Shell
                                                        </label>
                                                    </div>
                                                </td>
                                            </> :
                                            <>
                                                <td className="text-center">-</td>
                                                <td className="text-center">-</td>
                                            </>
                                        }
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={12} className='text-center'>Record not found</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        )
    }


    render() {
        const { isLoading, StallPossessionChecklistList, stallTypeList } = this.state


        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />


                    <div className="main-container p-2">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <div className="position-relative">
                                    <h6 className="mb-0 p-2 text-white">Stall Possession Checklist Setup</h6>
                                </div>
                            </div>
                        </div>
                        <div className="row exb-top-space" style={{ margin: 'auto' }}>
                            <div className="table-responsive mt-2">
                                {this.record(StallPossessionChecklistList)}
                            </div>
                            <div class="col-md-12 mt-2">
                                <button type="button" class="btn btn-aqua rounded-1" style={{ float: 'right' }} disabled={!this.getWriteAccess()}
                                    onClick={() => this.insertUpdateStallPossessionChecklist()}>
                                    Save
                                </button>
                                <button class="btn rounded-1 btn-aqua" style={{ float: 'right', marginRight: '10px' }}
                                    onClick={() => this.addParent()}>
                                    Add More Category
                                </button>
                            </div>
                        </div>
                    </div>

                </>

            </>
        );
    }
}

export default withRouter(connect(null, { fill_action, insertUpdateStallPossessionChecklist_action, getStallPossessionChecklistDetails_action })(StallPossessionChecklist));